"use client";

import { StudioChartMockup } from "@/components/redesign/StudioChartMockup";
import type { ChartMockupBlockProps } from "@/puck/types";

export function ChartMockupBlock({
  rows,
  footnote,
  showTrendArrow,
}: Readonly<ChartMockupBlockProps>) {
  return (
    <div className="h-full min-h-[16rem]">
      <StudioChartMockup
        rows={rows}
        footnote={footnote}
        showTrendArrow={showTrendArrow}
      />
    </div>
  );
}
